export const BRAND_NAME = 'DreamScholars';
export const SUBSCRIPTION_FORM_URL = 'https://forms.gle/qCpPA34L7ZNVpGH27';
